(function ($) {
    $(document).ready(function () {
        var _swatchColor = $('.color-item');
        if (_swatchColor.length) {
            setTimeout(function () {
                _swatchColor.removeClass('_color_item');
            }, 250);
        }
        $("#cart-icon-bubble, #cart-icon-header, .minicart-overlay, .cart-notification__close").on('click', function () {
            var _container = $('.cart-notification-wrapper');
            if (_container.hasClass('active')) {
                _container.removeClass('open');
                setTimeout(function () {
                    _container.removeClass('active');
                }, 250);
            } else {
                _container.addClass('active');
                setTimeout(function () {
                    _container.addClass('open');
                }, 250);
            }
        });

        var login_recover = $('.login-notification_recover');
        var login_notification = $('.login-notification_login');

        $(".header__icon--account, .login-overlay, .login-notification__close").on('click', function (e) {
            e.preventDefault();

            var _container = $('.login-notification-wrapper');
            if (_container.hasClass('active')) {
                _container.removeClass('open');
                setTimeout(function () {
                    _container.removeClass('active');
                }, 250);
            } else {
                _container.addClass('active');
                setTimeout(function () {
                    _container.addClass('open');
                }, 250);
            }
        });

        if (login_recover.length && login_notification.length) {
            var hash = window.location.hash;
            if (hash === '#recover') {
                window.location.hash = '';
                login_notification.removeClass('open');
                login_recover.addClass('open');
            }
            //#recover
            $('.action-notification_recover').on('click', function (e) {
                e.preventDefault();
                login_notification.removeClass('open');
                login_recover.addClass('open');
            });

            $('.action-notification_recover-cancel').on('click', function (e) {
                e.preventDefault();
                login_notification.addClass('open');
                login_recover.removeClass('open');
            });
        }

        $(window).on('scroll', function () {
            var _next = $('.spot-load-more');
            if (_next && _next.length && _next.isInViewport()) {
                if (!_next.hasClass('loading')) {
                    _next.click();
                }

            }

        });

        var submenu = $('.menu__menu.has-submenu');
        var container = $('.menu__inner-container');
        if (submenu.length && container.length) {
            var action = $('[data-level-action]');
            $('.toggle-menu-mobile').on('click', function () {
                $(window).scrollTop(0);
                submenu.attr('data-level-active', 0);
                container.attr('data-active', 0);
            });
            action.on('click', function () {
                var _level = $(this).attr('data-level-action');
                submenu.attr('data-level-active', _level);
                container.attr('data-active', _level);
            });
        }

        var mobile_footer_item = $('.site-footer__linklist-item');
        if (mobile_footer_item.length) {
            mobile_footer_item.each(function () {
                var item = $(this);
                var _action = $(this).find('.link-title');
                _action.on('click', function () {
                    item.toggleClass('open');
                });
            });
        }

        if (window.blog && window.blog.articles && window.blog.articles.length) {
            var _initCount = window.blog.articles.length;
            var _urls = window.blog.urls;
            var articlesJson = window.blog.articlesJson;
            var imagesJson = window.blog.imagesJson;

            var _perPage = window.blog.perPage;
            var offset = 0;
            var content = $('.blog-items_grid');
            var contentItem = $('.blog-items-grid');
            var loadMore = $('<button/>');

            var _loadMore = function () {
                var size = Math.min(window.blog.articles.length, _perPage + offset);

                for (var count = offset; count < size; count++) {
                    var _url = null;
                    var _blog = null;
                    var _img = null;

                    if (_urls && _urls[count]) {
                        _url = _urls[count];
                    }
                    if (articlesJson && articlesJson[count]) {
                        _blog = articlesJson[count];
                    }
                    if (imagesJson && imagesJson[count]) {
                        _img = imagesJson[count];
                    }

                    var item = window.blog.articles[count];

                    var _item = $('<div/>')
                        .addClass('blog-item-grid')
                        .appendTo(contentItem);

                    if (_url) {
                        var _nameDiv = $('<div/>')
                            .addClass('blog-item-grid-name check_load')
                            .appendTo(_item);

                        var _link = $('<a/>')
                            .attr('href', _url)
                            .appendTo(_nameDiv);

                        if (_img) {
                            $('<div/>')
                                .addClass('blog-item-grid-image check_load-image')
                                .html(_img)
                                .appendTo(_link);
                        }

                        $('<div/>')
                            .html(item.title)
                            .appendTo(_link);
                    }

                    var date = new Date(item.published_at);
                    var options = {
                        year: 'numeric', month: 'long', day: 'numeric'
                    };

                    if (_blog) {
                        var _dateDiv = $('<div/>')
                            .addClass('blog-item-grid-blog_date')
                            .html('<span>' + _blog + '</span> | <span>' + date.toLocaleString('en-US', options) + '</span>')
                            .appendTo(_item);
                    }

                    var _htmlDiv = $('<div/>')
                        .addClass('blog-item-grid-blog_content')
                        .html(item.body_html.slice(0, 150) + '...')
                        .appendTo(_item);

                    var _actionsDiv = $('<div/>')
                        .addClass('blog-item-grid-blog_actions')
                        .html('<a href="' + _url + '">Read More</a>')
                        .appendTo(_item);
                }

                offset += _perPage;
                if (_initCount < 1) {
                    loadMore.remove();
                }
            }

            loadMore
                .addClass('load-more')
                .html('Load more')
                .on('click', function () {
                    _initCount -= _perPage;
                    _loadMore();
                })
                .appendTo(content);
        }
        $('.promo-bar-slider').slick({
            dots: false,
            infinite: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: true,
            autoplay: true,
            autoplaySpeed: 7000
        });

        $('.fb-share').on('click', function (e) {
            e.preventDefault();
            window.open($(this).attr('href'), 'fbShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
            return false;
        });

        var _searchMobile = $('.search-item-mobile button');
        _searchMobile.on('click', function () {
            $('.search-box_header').toggleClass('open');
        });
        $(document).on('click', function (event) {
            var container = $(".search-box_header, .search-item-mobile button");
            if (!container.is(event.target)
                && container.has(event.target).length === 0) {
                $('.search-box_header').removeClass('open');
            }
        });


        var filter_by_category_item = $('.filter-by-category .item-layered');
        if (filter_by_category_item.length) {
            filter_by_category_item.each(function () {
                $(this).find('.category-layered').on('click', function () {
                    $(this).parent().toggleClass('active');
                });
            });
        }


        var _sort = $('select.plp-spot-sort');
        if (_sort.length) {
            var _content = $('.content-sort');
            var _options = _sort.find('option');
            var _labelSelected = $('input[name=default-sort]').val();
            _sort.val(_labelSelected);
            var _sortMobile = $('<div/>')
                .addClass('facet')
                .addClass('active')
                .addClass('_mobile')
                .appendTo('.plp-spot-pane .facets');

            var _facetTile = $('<div/>')
                .addClass('facet-title')
                .html('<span>Sort</span><span class="item-sort-active"></span>')
                .on('click', function () {
                    _sortMobile.toggleClass('active')
                })
                .appendTo(_sortMobile);
            var _facetValues = $('<div/>')
                .addClass('facet-values')
                .appendTo(_sortMobile);
            var _facetOrganiser = $('<div/>')
                .addClass('facet-organizer')
                .appendTo(_facetValues);


            _options.each(function () {
                var _option = $(this);
                var label = $(this).text();
                var value = $(this).attr('value');
                if (value === _labelSelected) {
                    $(this).attr('selected', true);
                    _content.find('.sort-label').text(label);
                    $('.item-sort-active').text(label);
                }

                var _div = $('<button/>')
                    .addClass('item-sort')
                    .addClass(_labelSelected === value ? 'active' : '')
                    .text(label)
                    .attr('data-value', value)
                    .attr('data-text', label)
                    .on('click', function () {
                        _content.find('.sort-label').text($(this).attr('data-text'));
                        _content.find('button').removeClass('active');
                        _options.removeAttr('selected');
                        _option.attr('selected', 'selected');
                        spotDOM.sort($(this).attr('data-value'));
                        $(this).addClass('active');
                    })
                    .appendTo(_content.find('.sort-items'));

                var _facetSortItem = $('<div/>')
                    .addClass('item-facet')
                    .appendTo(_facetOrganiser);

                var _input = $('<input/>')
                    .addClass('item-sort')
                    .attr('checked', _labelSelected === value)
                    .attr('type', 'radio')
                    .attr('name', 'item-sort')
                    .attr('data-value', value)
                    .attr('data-text', label)
                    .on('click', function () {
                        $('.item-sort-active').text($(this).attr('data-text'));
                        _options.removeAttr('selected');
                        _option.attr('selected', 'selected');
                        spotDOM.sort($(this).attr('data-value'));
                    })
                    .appendTo(_facetSortItem);

                var _name = $('<span/>')
                    .addClass('name')
                    .text(label)
                    .appendTo(_facetSortItem);
            });


            _sort.on('change');
        }

        var _labelSort = $('.plp-sort-wrap .content-sort');
        if (_labelSort.length) {
            var _action = _labelSort.find('.sort-label');
            _action.on('click', function () {
                _labelSort.toggleClass('open');

            });
            $(document).on('click', function (event) {
                if (!_action.is(event.target)
                    && _action.has(event.target).length === 0) {
                    _labelSort.removeClass('open');
                }
            });
        }

        var _updateCountFilter = function () {
            var _plpBreadcrumb = $('.plp-spot-breadcrumb');
            var _count = _plpBreadcrumb.find('button');

            if (_count && _count.length > 1) {
                $('.count-sort').html('&nbsp;(' + (_count.length - 1) + ')');
            } else {
                $('.count-sort').html('');
            }
        }

        var _closeFilters = $('.filter-sort_mobile-action, .filter-header-mobile .close, .filter-footer-mobile .apply');
        if (_closeFilters.length) {
            _closeFilters.on('click', function () {
                $('.filter-sort_mobile-content').toggleClass('open');
                _updateCountFilter();
            });
        }

        var _resetFilters = $('.filter-footer-mobile .clear');
        if (_resetFilters.length) {
            _resetFilters.on('click', function () {
                $('.clear-breadcrumbs.btn.button').trigger('click');
                _updateCountFilter();
            });
        }

        var _filterCategoryMobile = $('.filter-by-subcategory_mobile');
        if (_filterCategoryMobile.length) {
            var _categoryOpen = _filterCategoryMobile.find('.section-title .category-layered');
            _categoryOpen.on('click', function () {
                _filterCategoryMobile.toggleClass('open');
            });
        }


        var _t = 0;
        var _nb = 0;
        // var _instaFeed = function(){
        //     var _feed = $('#insta-feed');
        //     if(_feed.find('a').length) {
        //         clearInterval(_t);
        //         _t = 0;
        //         _feed.css('opacity', 1);
        //         _feed.slick({
        //             dots: true,
        //             infinite: false,
        //             speed: 300,
        //             slidesToShow: 5,
        //             slidesToScroll: 1,
        //             arrows: true,
        //             draggable: true,
        //             responsive: [
        //                 {
        //                     breakpoint: 1921,
        //                     settings: {
        //                         slidesToShow: 4
        //                     }
        //                 },
        //                 {
        //                     breakpoint: 1246,
        //                     settings: {
        //                         arrows: false,
        //                         slidesToShow: 3
        //                     }
        //                 },
        //                 {
        //                     breakpoint: 768,
        //                     settings: {
        //                         arrows: false,
        //                         slidesToShow: 2
        //                     }
        //                 },
        //             ]
        //         });
        //     } else {
        //         _nb += 1;
        //         if(_nb === 30){
        //             clearInterval(_t);
        //             _t = 0;
        //         }
        //     }

        // };

        var _resetSearch = function () {
            var form = $('.search-result_form');
            if (form.length) {
                var _input = form.find('input[type="search"]');
                var _reset = form.find('.reset-button_header');
                _reset.on('click', function () {
                    _input.attr('value', '');
                });
            }
        };

        var _facetOrganizer = function () {
            var _itemFacet = $('.facets .facet');
            if (_itemFacet.length) {
                _itemFacet.each(function () {
                    var _this = $(this);
                    var _title = _this.find('.facet-title .selected');
                    var _checked = _this.find('input:checked');
                    if (_title.length) {
                        if (_checked.length) {
                            _title.text(_checked.length + ' selected');
                        } else {
                            _title.text();
                        }
                    }
                });
            }
        };

        if (window.location.pathname.indexOf('/apps/store-locator') > -1) {
            var _mainContent = $('#MainContent');
            var _colMain = $('#col-main');
            var _wrapperPage = $('<div>')
                .addClass('page-width')
                .appendTo(_mainContent);
            _colMain.appendTo(_wrapperPage);

            var _storeLocator = $('<div>')
                .addClass('store-locator-content')
                .appendTo(_colMain);
            var _storeLocatorLeft = $('<div>')
                .addClass('store-locator-content_left')
                .appendTo(_storeLocator);
            var _storeLocatorRight = $('<div>')
                .addClass('store-locator-content_right')
                .appendTo(_storeLocator);

            _colMain.find('.search_bar').appendTo(_storeLocatorLeft);
            _colMain.find('#addresses_list').appendTo(_storeLocatorLeft);
            _colMain.find('#directions_text').appendTo(_storeLocatorLeft);
            _colMain.find('#store_map').appendTo(_storeLocatorRight);


            _colMain.appendTo(_wrapperPage);
        }

        var _create_customer = $('#create_customer');
        if (_create_customer.length) {
            var _action = _create_customer.find('.sign-in');
            _action.on('click', function (e) {
                e.preventDefault();
                var _submit = true;
                _create_customer.find('.error-message').remove();
                var _input = _create_customer.find('input');
                _input.each(function () {
                    if (!$(this).val()) {
                        var _error = $('<span/>')
                            .addClass('error-message')
                            .text('This is a required field.\n')
                            .insertAfter($(this));
                        _submit = false;
                    }
                });
                if (_submit) {
                    _create_customer.submit();
                }
            });
        }

        var isSearch = $("search-form.search-modal_form");
        if (isSearch.length) {
            $('input.search-input_header').blur(function () {
                isSearch.removeClass("focus");
            })
                .focus(function () {
                    isSearch.addClass("focus")
                });
        }

        var wishlist_empty_callout = function () {
            var _emptyWishlist = $('.wk-wishlist-empty-callout');
            if (_emptyWishlist.length) {
                var _button = _emptyWishlist.find('.wk-callout-cta');
                _button.attr('href', '/pages/all-brands');
                if (window.emptyWishlit.showButton) {
                    _button.css('display', 'inline-flex');
                }
            }
        }

        _facetOrganizer();
        _resetSearch();
        _t = setInterval(_instaFeed, 250);
        _updateCountFilter();
        setTimeout(wishlist_empty_callout, 750);
    });

    $.fn.isInViewport = function () {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    };
    var _toggleCorporate = $('.form__toggle');
    if (_toggleCorporate.length) {
        var _container = $('.corporate-form_shg');
        var _close = _container.find('._close');
        _toggleCorporate.each(function () {
            var $this = $(this);
            $this.add(_close).on('click', function () {

                if (_container.hasClass('active')) {
                    _container.removeClass('open');
                    setTimeout(function () {
                        _container.removeClass('active');
                    }, 250);
                } else {
                    _container.addClass('active');
                    setTimeout(function () {
                        _container.addClass('open');
                    }, 250);
                }
            });
        });
    }

})(jQuery);

